import { Property } from '@propertypal/shared/src/types/property';
import Button from '@propertypal/web-ui/src/buttons/Button';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { LinkText, SmallHeading, Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import router from 'next/router';
import React, { FunctionComponent } from 'react';
import { Heading, Table, TextBox } from './PropertyUnits.style';

interface Props {
  property: Property;
}

const PropertyUnits: FunctionComponent<Props> = (props) => {
  if (!props.property.units || !props.property.development) {
    return null;
  }

  const developmentUrl = props.property.development.path;

  return (
    <PageWrapper containerStyle={{ paddingBottom: 60 }} className="pp-property-units">
      <Heading>
        <TextBox>
          <SmallHeading fontSize={20} fontWeight="600" mb={15}>
            {props.property.development.name} Development
          </SmallHeading>

          <Text>
            This property forms part of the <b>{props.property.development.name}</b> development. <br />
            <Link href={developmentUrl} passHref prefetch={false}>
              <LinkText>Click to view</LinkText>
            </Link>{' '}
            all available property type within this development.
          </Text>
        </TextBox>

        <Button containerStyle={{ maxWidth: 260 }} onClick={() => router.push(developmentUrl)}>
          View the Development
        </Button>
      </Heading>

      {!!props.property.units.length && (
        <Table>
          <thead>
            <tr>
              <th>Unit Name</th>
              <th>Price</th>
              <th>Size</th>
            </tr>
          </thead>

          <tbody>
            {props.property.units.map((unit) => (
              <tr key={unit.name}>
                <td>{unit.name}</td>
                <td>
                  <b>{unit.price}</b>
                </td>
                <td>{unit.size}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </PageWrapper>
  );
};

export default PropertyUnits;
